import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { extTasksApi } from '../lib/api';

// Tipo di azione accodata: l'utente la esegue A MANO su LinkedIn (copilota)
export type ExtTaskType = 'visit_profile' | 'comment_post' | 'send_dm' | 'custom';

// Stato del task: in attesa, completato o saltato dall'utente
export type ExtTaskStatus = 'pending' | 'done' | 'skipped';

// Task come restituito da GET /ext/tasks (con join sul nome del contatto)
export interface ExtTask {
  id: string;
  contact_id: string | null;
  task_type: ExtTaskType | string;
  target_url: string;
  note: string | null;
  status: ExtTaskStatus | string;
  created_at: string;
  completed_at: string | null;
  contacts?: { full_name: string } | null;
}

export function useExtTasks(status?: string) {
  return useQuery({
    queryKey: ['ext-tasks', status ?? 'all'],
    queryFn: async () => {
      const res = await extTasksApi.list(status);
      return (res?.tasks ?? res ?? []) as ExtTask[];
    },
  });
}

export function useCreateExtTask() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: {
      task_type: string;
      target_url: string;
      contact_id?: string | null;
      note?: string | null;
    }) => extTasksApi.create(input),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ext-tasks'] }),
  });
}

export function useDeleteExtTask() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => extTasksApi.remove(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['ext-tasks'] }),
  });
}
